module.exports = __webpack_public_path__ + "img/sirius-xm_vehicle-program-card.9468eba0.png";